import React, { useState } from 'react';

const ComponentPreview = ({ component: Component, code, title, description }) => {
    const [activeTab, setActiveTab] = useState('preview');

    return (
        <div className="space-y-6">
            <div className="space-y-2 px-2 md:px-0">
                <h2 className="text-2xl md:text-3xl font-bold text-white tracking-tight">{title}</h2>
                <p className="text-gray-400 text-base md:text-lg leading-relaxed max-w-full md:max-w-2xl">{description}</p>
            </div>

            <div className="rounded-xl border border-white/10 bg-[#0a0a0a] overflow-hidden">
                <div className="flex items-center px-3 md:px-4 border-b border-white/10 bg-white/5">
                    <button
                        onClick={() => setActiveTab('preview')}
                        className={`px-3 md:px-4 py-3 text-xs md:text-sm font-medium transition-colors relative ${activeTab === 'preview' ? 'text-white' : 'text-gray-400 hover:text-gray-200'
                            }`}
                    >
                        Preview
                        {activeTab === 'preview' && (
                            <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-white rounded-t-full" />
                        )}
                    </button>
                    <button
                        onClick={() => setActiveTab('code')}
                        className={`px-3 md:px-4 py-3 text-xs md:text-sm font-medium transition-colors relative ${activeTab === 'code' ? 'text-white' : 'text-gray-400 hover:text-gray-200'
                            }`}
                    >
                        Code
                        {activeTab === 'code' && (
                            <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-white rounded-t-full" />
                        )}
                    </button>
                </div>

                <div className="p-0">
                    {activeTab === 'preview' ? (
                        <div className="relative min-h-[500px] md:min-h-[600px] lg:min-h-[700px] w-full flex items-center justify-center bg-black overflow-hidden">
                            <div className="absolute inset-0 w-full h-full">
                                <Component />
                            </div>
                        </div>
                    ) : (
                        <div className="relative bg-[#0d1117] p-4 overflow-x-auto max-h-[600px] overflow-y-auto">
                            <pre className="text-sm font-mono text-gray-300 leading-relaxed">
                                <code>{code}</code>
                            </pre>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ComponentPreview;
